import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { FC } from 'react';
import { useDebugMode } from '@app/providers/DebugModeProvider';

interface DebugPanelProps {
  displayItem: any;
}

/**
 * Off by default. Turn it on for your own account from the admin screen — see
 * `DebugModeProvider` for why it isn't simply on for the whole dev environment.
 */
export const DebugPanel: FC<DebugPanelProps> = ({ displayItem }) => {
  const { enabled } = useDebugMode();
  if (!enabled) return null;
  return (
    <Box
      data-testid="debug-panel"
      sx={{
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto',
        padding: 1,
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
        borderRadius: 1,
        mt: 2,
      }}
    >
      <Accordion>
        <AccordionSummary>Debug</AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 300, overflowY: 'auto' }}>
          <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
            {JSON.stringify(displayItem, null, 2)}
          </pre>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
